// Runtime settings, read from REACT_APP_* environment variables (see .env.example).
// Never put secrets here: everything in a React bundle is visible to users.

const env = process.env;
const bool = (v, fallback = false) => (v === undefined || v === '' ? fallback : v === 'true');
const num = (v, fallback) => (Number.isFinite(Number(v)) && v !== '' && v !== undefined ? Number(v) : fallback);

const isProduction = env.NODE_ENV === 'production';

export const appConfig = Object.freeze({
  env: env.NODE_ENV,
  isProduction,

  api: Object.freeze({
    // Base URL of the backend, e.g. https://api.routebag.com/v1
    baseURL: (env.REACT_APP_API_BASE_URL || '/api/v1').replace(/\/+$/, ''),
    timeoutMs: num(env.REACT_APP_API_TIMEOUT_MS, 20000),
    // Send cookies (httpOnly refresh token) with API requests.
    withCredentials: true,
    // Double-submit CSRF token: backend sets this cookie, axios echoes it in the header.
    xsrfCookieName: env.REACT_APP_XSRF_COOKIE || 'XSRF-TOKEN',
    xsrfHeaderName: env.REACT_APP_XSRF_HEADER || 'X-XSRF-TOKEN',
  }),

  auth: Object.freeze({
    // Sign out after this many minutes without user activity (0 disables).
    idleTimeoutMinutes: num(env.REACT_APP_IDLE_TIMEOUT_MINUTES, 30),
    // Refresh the access token this many seconds before it expires.
    refreshLeewaySeconds: 60,
    // Local demo accounts instead of the real auth API. Can never be on in a production build.
    useMockAuth: !isProduction && bool(env.REACT_APP_USE_MOCK_API, false),
  }),

  places: Object.freeze({
    dataURL: env.REACT_APP_PLACES_DATA_URL || 'https://pub-9b24add32f5740d88f5d4964aab0dedb.r2.dev/assets/Data',
    googleMapsKey: env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  }),
});

export default appConfig;
